// SDS host stack for the inventory orchestrator. Count session lives
// in Production → Inventory count (ManufacturingInventoryCountPanel).
import type { MfgMaterial } from "@/lib/manufacturing/types";
import { ManufacturingMaterialSdsHost } from "./ManufacturingMaterialSdsHost";
import { ManufacturingSdsBookHost } from "./ManufacturingSdsBookHost";

type Props = {
  enabled: boolean;
  sdsMaterial: MfgMaterial | null;
  onSdsClose: () => void;
  sdsBookOpen: boolean;
  onSdsBookClose: () => void;
};

export function ManufacturingInventoryPanelHosts(props: Props) {
  return (
    <>
      <ManufacturingMaterialSdsHost
        open={!!props.sdsMaterial}
        enabled={props.enabled}
        material={props.sdsMaterial}
        onClose={props.onSdsClose}
      />
      <ManufacturingSdsBookHost
        open={props.sdsBookOpen}
        enabled={props.enabled}
        onClose={props.onSdsBookClose}
      />
    </>
  );
}
